module.exports = __webpack_public_path__ + "static/media/tara-bot.7e411cae.svg";